import { Swiper, SwiperSlide } from "swiper/react";
import { useBreakpoint } from "@ef-global/backpack/hooks";

import "swiper/css";
import "swiper/css/navigation";

import { Navigation } from "swiper/modules";

import styles from "./swiper.module.scss";

import Components from "../components";
import classnames from "classnames";
import { ArrowLeftIcon, ArrowRightIcon } from "@phosphor-icons/react";

const SwiperComponent = (props: { blok: any }) => {
  const { breakpoint } = useBreakpoint("unknown");

  const numberOfItems = props.blok.items.length;

  function getSlidesPerViewInBreakpoint() {
    if (breakpoint === "s") {
      return 1;
    }

    if (breakpoint === "m" && numberOfItems > 2) {
      return 2;
    }

    return 3;
  }

  const slidesInBreakpoint = getSlidesPerViewInBreakpoint();

  const slidesPerView =
    numberOfItems < slidesInBreakpoint
      ? numberOfItems
      : slidesInBreakpoint + 0.2;

  return (
    <Swiper
      navigation={{
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      }}
      modules={[Navigation]}
      slidesPerView={slidesPerView}
      grabCursor={true}
      className={classnames(styles.wrapper, {
        [styles.leftPadding]: props.blok.leftPadding,
      })}
      spaceBetween={20}
    >
      {props.blok.items.map((item: any) => {
        const Component = Components(item.component);
        return (
          <SwiperSlide key={item._uid} style={{ height: "initial" }}>
            <Component blok={item} />
          </SwiperSlide>
        );
      })}
      <div className={styles.scrollCarouselButtons}>
        <button type="button" className="swiper-button-prev">
          <ArrowLeftIcon size={16} weight="bold" aria-hidden="true" />
        </button>
        <button type="button" className="swiper-button-next">
          <ArrowRightIcon size={16} weight="bold" aria-hidden="true" />
        </button>
      </div>
    </Swiper>
  );
};

export default SwiperComponent;
